import { render, staticRenderFns } from "./DialogTask.vue?vue&type=template&id=7be3483c"
import script from "./DialogTask.vue?vue&type=script&lang=js"
export * from "./DialogTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports